import { NavLink } from "react-router-dom";
import { ROUTE_PATH } from "../../contants/routePath";
import Logo from "../../assets/logo.png";
const Navbar = () => {
  return (
    <nav className="bg-secondary shadow">
      <div className=" px-4">
        <div className="relative flex h-16 items-center justify-between">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
            {/* <!-- Mobile menu button--> */}
            <button
              type="button"
              className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded="false"
            >
              <span className="absolute -inset-0.5"></span>
              <span className="sr-only">Open main menu</span>
              {/* <!--
            Icon when menu is closed.
            Menu open: "hidden", Menu closed: "block"
          --> */}
              <svg
                className="block h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
              {/* <!--
            Icon when menu is open.
            Menu open: "block", Menu closed: "hidden"
          --> */}
              <svg
                className="hidden h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="flex flex-1 items-center justify-center sm:justify-between">
            <div className="flex flex-shrink-0 items-center">
              <img className="h-16 w-auto" src={Logo} alt="Your Company" />
            </div>
            <div className="hidden sm:ml-6 sm:block">
              <div className="flex space-x-4">
                {/* <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" --> */}
                <NavLink
                  to={ROUTE_PATH.plantManagement}
                  className="rounded-full no-underline bg-[#FFFFFF] px-3 py-2 text-sm font-medium text-primaryText hover:shadow-sm hover:shadow-primary "
                  aria-current="page"
                >
                  Plant Management
                </NavLink>
                <NavLink
                  to={ROUTE_PATH.lgv}
                  className="rounded-full px-3  no-underline bg-[#FFFFFF] py-2 text-sm font-medium text-primaryText hover:border-primary hover:shadow-sm hover:shadow-primary"
                >
                  Back To LGV
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Mobile menu, show/hide based on menu state. --> */}
      <div className="sm:hidden" id="mobile-menu">
        <div className="space-y-1 px-2 pb-3 pt-2">
          {/* <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" --> */}
          <NavLink
            to={ROUTE_PATH.plantManagement}
            className="block rounded-md no-underline bg-white px-3 py-2 text-base font-medium text-primaryText"
            aria-current="page"
          >
            Plant Management
          </NavLink>
          <NavLink
            to={ROUTE_PATH.lgv}
            className="block rounded-md no-underline bg-white px-3 py-2 text-base font-medium text-primaryText hover:border-primary hover:border-2 hover:text-[#20242B]"
          >
            Back To LGV
          </NavLink>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
